module.exports = __webpack_public_path__ + "img/nt86-00-82-1.asm.a4908fcf.jpg";